import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { SchedulerSettingsService } from '../../services/scheduler-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApplicationSettingsComponent } from '../application-settings/application-settings.component';

@Component({
    standalone: false,
    selector: 'app-settings-button',
    templateUrl: './settings-button.component.html',
    styleUrls: ['./settings-button.component.scss']
})
export class SettingsButtonComponent implements OnInit {
    constructor(
        protected readonly dialog: MatDialog,
        protected readonly schedulerSettingsService: SchedulerSettingsService,
        private readonly snackBar: MatSnackBar
    ) {}

    ngOnInit(): void {}

    openSettingsModal() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.minWidth = '600px';

        const dialogRef = this.dialog.open(ApplicationSettingsComponent, dialogConfig);

        dialogRef
            .afterClosed()
            .pipe(filter(result => result))
            .subscribe((scheduleSettings: ISchedulerSettings) => {
                this.schedulerSettingsService.updateSchedulerSettings(scheduleSettings).subscribe(() => {
                    this.snackBar.open(`Scheduler Settings successfully saved`, 'OK', {
                        verticalPosition: 'top',
                        horizontalPosition: 'center',
                        duration: 3000
                    });
                });
            });
    }
}
